<template>
  <Modal :open="open" @close="close">
    <h2 class="text-lg font-semibold mb-4 text-center w-full">Clôturer le sinistre</h2>
    <p class="mb-4">Veuillez préciser les informations de remboursement pour clôturer ce sinistre.</p>

    <div class="space-y-4">
      <Selector
        id="refundedEntity"
        name="refundedEntity"
        v-model="formData.refundedEntity"
        label="Entité remboursée"
        label-class="block text-sm font-medium leading-6 text-gray-900"
        :required="true"
        :options="refundedEntityOptions"
        default-option-text="-- Sélectionner --"
      />

      <FormField
        id="refundedAmount"
        v-model="formData.refundedAmount"
        type="number"
        label="Montant remboursé (€)"
        label-class="block text-sm font-medium leading-6 text-gray-900"
        placeholder="0.00"
        step="0.01"
        min="0"
        required
      />

      <RadioButtons
        id="send_trustpilot_link"
        name="sendTrustpilotLink"
        label="Envoyer le lien trustpilot au client"
        v-model="formData.sendTrustpilotLink"
        :valueOptions="sendTrustpilotLinkOptions"
      />
    </div>

    <div class="flex justify-center space-x-3 mt-6">
      <SecondaryButton
        @click="handleResolve"
        :loading="loading"
        :disabled="!isFormValid"
        class="bg-green-100 hover:bg-green-200 text-green-700"
      >
        Clôturer le sinistre
      </SecondaryButton>
      <SecondaryButton @click="close">Annuler</SecondaryButton>
    </div>
  </Modal>
</template>

<script>
import { Modal, FormField, SecondaryButton, Selector, RadioButtons } from "@estaly/ui";
import { mapActions, mapState } from "vuex";

function defaultFormData() {
  return {
    refundedEntity: "",
    refundedAmount: null,
    sendTrustpilotLink: false,
  };
}

export default {
  components: { RadioButtons, FormField, SecondaryButton, Modal, Selector },
  props: ["open", "claim"],
  emits: ["close"],

  data() {
    return {
      formData: defaultFormData(),
      loading: false,
      refundedEntityOptions: [
        { value: "merchant", label: "Marchand" },
        { value: "customer", label: "Client" },
      ],
    };
  },

  computed: {
    ...mapState("claims", ["currentClaim"]),

    activeClaim() {
      return this.claim || this.currentClaim;
    },

    sendTrustpilotLinkOptions() {
      return [
        { value: true, label: "Oui" },
        { value: false, label: "Non" },
      ];
    },

    isFormValid() {
      const refundedAmount = this.formData.refundedAmount;
      const numericRefundedAmount = Number(refundedAmount);
      return (
        Boolean(this.formData.refundedEntity) &&
        refundedAmount !== "" &&
        refundedAmount !== null &&
        Number.isFinite(numericRefundedAmount) &&
        numericRefundedAmount >= 0
      );
    },
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.initializeForm();
      }
    },
  },

  methods: {
    ...mapActions("claims", ["resolveClaim"]),

    initializeForm() {
      const claim = this.activeClaim;
      if (!claim) return;

      this.formData.refundedEntity = claim.refundedEntity ?? "";
      this.formData.refundedAmount = claim.refundedAmount ?? claim.invoice?.repairCost ?? 0;
    },

    async handleResolve() {
      if (!this.isFormValid) return;

      this.loading = true;
      const response = await this.resolveClaim({
        refundedEntity: this.formData.refundedEntity,
        refundedAmount: this.formData.refundedAmount,
        sendTrustpilotLink: this.formData.sendTrustpilotLink,
      });
      this.loading = false;
      if (!response?.success) return;

      this.$emit("close");
    },

    close() {
      this.$emit("close");
      this.formData = defaultFormData();
    },
  },
};
</script>
